import React, { useState, useEffect, useRef } from 'react';
import { Globe, Calendar, Users, Award, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import axios from 'axios';

const StatsAndTestimonials = () => {
  const [stats, setStats] = useState({
    destinations: 0,
    bookings: 0,
    clients: 0,
    providers: 0
  });
  const [hasAnimated, setHasAnimated] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const statsRef = useRef(null);
  const [TestimonialData, setTestimonialData] = useState([])

  const finalStats = {
    destinations: 50,
    bookings: 7000,
    clients: 100,
    providers: 89
  };

  const testimonials = [
    {
      id: 1,
      name: 'Andrew',
      location: 'Newyork, United States',
      rating: 5.0,
      text: 'Dream Tours is the only way to go. We had the time of our life on our trip to the Ark. The customer service was wonderful, and the staff was very...',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80'
    },
    {
      id: 2,
      name: 'Bryan',
      location: 'South Africa',
      rating: 5.0,
      text: 'Booking our dream cruise was incredibly easy with DreamsTour The interface was user-friendly, and I loved how we could compare different cruise lines.',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&q=80'
    },
    {
      id: 3,
      name: 'James',
      location: 'South Africa',
      rating: 5.0,
      text: 'Dream cruise was incredibly easy with DreamsTour The interface was user-friendly, and I loved how we could compare different cruise lines.',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80'
    },
    {
      id: 4,
      name: 'Prajakta',
      location: 'France',
      rating: 5.0,
      text: 'We had a fantastic time with activities for every age group, including a kids\' club. The cruise gave us memories to last a lifetime.',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80'
    }
  ];

    const fetchTestimonialData = async () => {
    
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/testimonial/get-all`
      );

      setTestimonialData(response?.data?.testimonials);
      console.log("TestimonialData", response);
    } catch (error) {
      console.error(error);
    }
   
  };

  useEffect(() => {
    fetchTestimonialData();
  }, []);

  const infiniteTestimonials = [
  ...TestimonialData,
  ...TestimonialData
];

useEffect(() => {
  if (currentTestimonial >= TestimonialData.length) {
    setCurrentTestimonial(0);
  }
}, [currentTestimonial, TestimonialData]);

  // Intersection Observer for counter animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          animateCounters();
          setHasAnimated(true);
        }
      },
      { threshold: 0.3 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  // Manual counter animation
  const animateCounters = () => {
    const duration = 2000; // 2 seconds
    const steps = 60;
    const interval = duration / steps;

    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      setStats({
        destinations: Math.floor(finalStats.destinations * progress),
        bookings: Math.floor(finalStats.bookings * progress),
        clients: Math.floor(finalStats.clients * progress),
        providers: Math.floor(finalStats.providers * progress)
      });

      if (currentStep >= steps) {
        clearInterval(timer);
        setStats(finalStats);
      }
    }, interval);
  };

  // Auto-slide testimonials
 useEffect(() => {
  if (TestimonialData.length === 0) return;

  const timer = setInterval(() => {
    setCurrentTestimonial((prev) => (prev + 1) % TestimonialData.length);
  }, 4000);

  return () => clearInterval(timer);
}, [TestimonialData]);

  const handlePrevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + TestimonialData.length) % TestimonialData.length);
  };

  const handleNextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % TestimonialData.length);
  };

  // const getVisibleTestimonials = () => {
  //   const visible = [];
  //   for (let i = 0; i < 4; i++) {
  //     visible.push(testimonials[(currentTestimonial + i) % testimonials.length]);
  //   }
  //   return visible;
  // };

  return (
    <div className="w-full bg-[#E5E9EE]">
      {/* Stats Section */}
      <div
        ref={statsRef}
        className="relative bg-gradient-to-r from-slate-800 via-slate-900 to-slate-800 py-12 px-4 sm:px-6 lg:px-8 overflow-hidden"
      >
        {/* Decorative Circles */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-orange-500 to-red-600 rounded-full opacity-20 -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute top-0 left-20 w-24 h-24 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full opacity-30"></div>
        <div className="absolute bottom-0 left-10 w-20 h-20 bg-gradient-to-br from-red-500 to-orange-600 rounded-full opacity-25 translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-40 h-40 bg-gradient-to-br from-orange-500 to-red-600 rounded-full opacity-20 translate-x-1/2 translate-y-1/2"></div>
        <div className="absolute bottom-10 right-10 w-32 h-32 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full opacity-25"></div>

        <div className="relative w-full mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Destinations */}
            <div className="text-center animate-fade-in-up">
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center backdrop-blur-sm">
                  <Globe className="w-6 h-6 text-cyan-400" />
                </div>
              </div>
              <h3 className="text-white/80 text-sm font-medium mb-2">Destinations Worldwide</h3>
              <div className="text-5xl font-bold text-white mb-1">
                {stats.destinations}
                <span className="text-cyan-400">+</span>
              </div>
            </div>

            {/* Bookings */}
            <div className="text-center animate-fade-in-up" style={{ animationDelay: '100ms' }}>
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center backdrop-blur-sm">
                  <Calendar className="w-6 h-6 text-cyan-400" />
                </div>
              </div>
              <h3 className="text-white/80 text-sm font-medium mb-2">Booking Completed</h3>
              <div className="text-5xl font-bold text-white mb-1">
                {stats.bookings.toLocaleString()}
                <span className="text-cyan-400">+</span>
              </div>
            </div>

            {/* Clients */}
            <div className="text-center animate-fade-in-up" style={{ animationDelay: '200ms' }}>
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center backdrop-blur-sm">
                  <Users className="w-6 h-6 text-cyan-400" />
                </div>
              </div>
              <h3 className="text-white/80 text-sm font-medium mb-2">Client Globally</h3>
              <div className="text-5xl font-bold text-white mb-1">
                {stats.clients}
                <span className="text-cyan-400">+</span>
              </div>
            </div>

            {/* Providers */}
            <div className="text-center animate-fade-in-up" style={{ animationDelay: '300ms' }}>
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center backdrop-blur-sm">
                  <Award className="w-6 h-6 text-cyan-400" />
                </div>
              </div>
              <h3 className="text-white/80 text-sm font-medium mb-2">Providers Registered</h3>
              <div className="text-5xl font-bold text-white mb-1">
                {stats.providers}
                <span className="text-cyan-400">+</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="py-10 px-4 sm:px-6 lg:px-20">
        <div className="w-full mx-auto">
          {/* Header */}
          <div className="text-center mb-16 animate-fade-in-up">
            {/* Decorative Icon */}
            <div className="flex justify-center mb-4">
              <div className="relative">
                {/* <div className="w-16 h-16 bg-gradient-to-r from-orange-400 to-red-500 rounded-2xl flex items-center justify-center shadow-lg transform rotate-6">
                  <svg className="w-10 h-10 text-white -rotate-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                </div> */}
                {/* Decorative swirl */}
                <svg className="absolute -right-12 -top-2 w-20 h-20 text-gray-300 opacity-50" viewBox="0 0 100 100" fill="none" stroke="currentColor">
                  <path d="M10,50 Q30,20 50,50 T90,50" strokeWidth="2" fill="none" />
                </svg>
              </div>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What's Our User Says
            </h2>
            <p className="text-gray-600 text-lg">
              Committed to Helping Our Clients Succeed.
            </p>
          </div>

          {/* Testimonials Carousel */}
          <div className="relative">
            <div className="overflow-hidden">
              <div
                className="flex transition-transform duration-700 ease-in-out"
                style={{
  transform: `translateX(-${currentTestimonial * 25}%)`
}}
              >
                {infiniteTestimonials?.map((testimonial, index) => (
                  <div
                    key={`${testimonial?._id}-${index}`} 
                    className="w-full sm:w-1/2 lg:w-1/4 flex-shrink-0 px-3"
                  >
                    <div className="bg-white rounded-2xl p-6 shadow-lg  transition-all duration-500 transform h-full border border-gray-100">
                      {/* Quote Icon */}
                      <div className="mb-4">
                        <Quote className="w-10 h-10 text-red-500" fill="currentColor" />
                      </div>

                      {/* Rating Stars */}
                    <div className="flex items-center space-x-1 mb-4">
  {[...Array(5)].map((_, i) => (
    <svg
      key={i}
      className={`w-5 h-5 ${
        i < Math.round(testimonial?.rating)
          ? "text-yellow-400"
          : "text-gray-300"
      }`}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
  ))}

  <span className="ml-2 text-gray-900 font-bold">
    {testimonial?.rating}
  </span>
</div>

                      {/* Testimonial Text */}
                      <p className="text-gray-600 text-sm leading-relaxed mb-6">
                        {testimonial?.description}
                      </p>

                      {/* User Info */}
                      <div className="flex items-center space-x-3 pt-4 border-t border-gray-100">
                        <img
                          src={testimonial?.image}
                          alt={testimonial?.name}
                          className="w-12 h-12 rounded-full object-cover border-2 border-orange-400"
                        />
                        <div>
                          <h4 className="font-bold text-gray-900">{testimonial?.name}</h4>
                          <p className="text-xs text-gray-500">{testimonial?.location}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={handlePrevTestimonial}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-600 group transition-all duration-300 hover:scale-110 z-10"
            >
              <ChevronLeft className="w-6 h-6 text-gray-700 group-hover:text-white transition-colors duration-300" />
            </button>

            <button
              onClick={handleNextTestimonial}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-600 group transition-all duration-300 hover:scale-110 z-10"
            >
              <ChevronRight className="w-6 h-6 text-gray-700 group-hover:text-white transition-colors duration-300" />
            </button>
          </div>

          {/* Pagination Dots */}
          <div className="flex justify-center space-x-2 mt-8">
            {TestimonialData.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`transition-all duration-300 rounded-full ${
                  index === currentTestimonial
                    ? 'w-8 h-3 bg-gradient-to-r from-orange-500 to-red-600'
                    : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Custom Animations */}
      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </div>
  );
};

export default StatsAndTestimonials;